"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/api/index.ts
var api_exports = {};
__export(api_exports, {
  FreeTrialStatus: () => import_api_client2.SubscriptionObjectFreeTrialStatus,
  SubscriptionPendingPlanInterval: () => import_api_client2.SubscriptionPlanObjectInterval,
  SubscriptionPlanInterval: () => import_api_client2.PathsSubscriptionPricesGetResponses200ContentApplicationJsonDataSubscriptionPricesInterval,
  SubscriptionPlanType: () => SubscriptionPlanType,
  SubscriptionTierType: () => SubscriptionTierType,
  subscriptionApi: () => subscriptionApi
});
module.exports = __toCommonJS(api_exports);
var import_api_client2 = require("@repo/api-client");

// src/api/api.ts
var import_api_client = require("@repo/api-client");
var subscriptionApi = {
  // subscription start
  /**
   * Create a subscription with given prices.
   * Upon success, a `clientSecret` is returned, which can be used for Stripe Elements.
   * @param data.prices
   * @param data.promoCode
   */
  createSubscription: async (data) => {
    const response = await import_api_client.apiFetchClient.POST("/subscription/create", {
      body: data
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Check whether a subscription can be created with given prices.
   * @param data.prices the prices to create a subscription with
   */
  canCreateSubscription: async (data) => {
    const response = await import_api_client.apiFetchClient.POST("/subscription/can_create", {
      body: data
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Fetches the subscription details for the current user/workspace.
   */
  showSubscription: async () => {
    const response = await import_api_client.apiFetchClient.GET("/subscription/show");
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Fetches a preview of the subscription to reflect the changes based on the provided data.
   * @param data the data for the preview
   */
  previewSubscriptionChange: async (data) => {
    const response = await import_api_client.apiFetchClient.POST("/subscription/change_preview", {
      body: data
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Cancels the current subscription.
   * @param data the data for the cancellation (reason)
   */
  cancelSubscription: async (data) => {
    const response = await import_api_client.apiFetchClient.POST(
      "/subscription/cancel_subscription",
      {
        body: data
      }
    );
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Schedules a cancellation of the current subscription.
   */
  cancelScheduledSubscription: async () => {
    const response = await import_api_client.apiFetchClient.POST("/subscription/cancel_schedule");
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Renews the current subscription.
   */
  renewSubscription: async () => {
    const response = await import_api_client.apiFetchClient.POST(
      "/subscription/renew_subscription"
    );
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Returns a Stripe payment intent for the last past due subscription available.
   */
  payPastDue: async () => {
    const response = await import_api_client.apiFetchClient.POST("/subscription/pay_past_due");
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Changes the current subscription.
   * @param data the data for the change (e.g. prices, promo code)
   */
  changeSubscription: async (data) => {
    const response = await import_api_client.apiFetchClient.POST("/subscription/change", {
      body: data
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Applies a cancellation discount to the monthly subscription.
   */
  applyCancellationDiscount: async () => {
    const response = await import_api_client.apiFetchClient.POST(
      "/subscription/cancellation_discount"
    );
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Verifies a promo code for the current subscription.
   * @param code the promo code to verify
   * @param data the data for the verification (e.g. prices user selected)
   */
  verifyPromoCode: async (code, data) => {
    const response = await import_api_client.apiFetchClient.POST(
      "/subscription/promo_code/{code}",
      {
        params: { path: { code } },
        body: data
      }
    );
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Fetches the subscription prices (e.g. plan/duration combinations)
   */
  getSubscriptionPrices: async () => {
    const response = await import_api_client.apiFetchClient.GET("/subscription/prices");
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  // subscription end
  // checkout start
  /**
   * Creates a Stripe portal for the current user/workspace.
   */
  createPortal: async () => {
    const response = await import_api_client.apiFetchClient.POST("/billing/portal/create");
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Creates a Stripe checkout for the current user/workspace.
   * @param data the data for the checkout
   */
  createCheckout: async (data) => {
    const response = await import_api_client.apiFetchClient.POST("/billing/checkout/create", {
      body: data
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Fetches the latest invoice for the current user/workspace.
   */
  getLatestInvoice: async () => {
    const response = await import_api_client.apiFetchClient.GET("/billing/invoice", {
      params: { query: { latestFromSubscription: "t" } }
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  // checkout end
  // products
  /**
   * Fetches a list of products from the server.
   *
   * The products represent AI Credits Plans, which vary depending on the user's subscription plan or eligibility.
   */
  getProducts: async () => {
    const response = await import_api_client.apiFetchClient.GET("/products/index", {
      params: {
        query: { type: import_api_client.PathsProductsIndexGetParametersQueryType.CREDITS }
      }
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  },
  /**
   * Creates a new order on the server.
   *
   * This function generates a new order based on the provided data and fetches a Stripe checkout link
   * for completing the purchase.
   *
   * @param data - The data for the order, adhering to the `OrderData` type.
   */
  createOrder: async (data) => {
    const response = await import_api_client.apiFetchClient.POST("/orders/oneclick/create", {
      body: data
    });
    if (response.data) {
      return response.data;
    } else {
      return response.error;
    }
  }
};
var SubscriptionPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  EXPERT: "EXPERT"
};
var SubscriptionTierType = {
  ...SubscriptionPlanType,
  BUSINESS: "BUSINESS"
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  FreeTrialStatus,
  SubscriptionPendingPlanInterval,
  SubscriptionPlanInterval,
  SubscriptionPlanType,
  SubscriptionTierType,
  subscriptionApi
});
